import { env } from './env'

// host から tenant(subdomain) を取り出す。
// - LOCKED ドメイン: `{tenant}.{SELF_DOMAIN}`（例 onetap.auth.locked.jp / onetap.lvh.me）
// - custom domain: `{tenant}.auth.{base}`（例 onetap.auth.acme.jp）
// path 先頭セグメントを tenant 扱いする旧実装は廃止（/login 等のページ名を誤認するため）。
export const getSubdomain = (host: string) => {
  // apex ガード: host（ポート除去後）が SELF_DOMAIN と完全一致するなら tenant 無し。
  // 例 stg env の `stg.auth.locked.jp`（apex）は selfSuffix='.stg.auth.locked.jp' が
  // host に含まれず（indexOf=-1）、後段の `.auth.` マーカー分岐に落ちて誤って 'stg' を
  // 返してしまう。prod env の apex `auth.locked.jp` も同様に保護する。
  const hostname = host.split(':')[0]
  if (hostname === env.SELF_DOMAIN) {
    return ''
  }

  const selfSuffix = '.' + env.SELF_DOMAIN
  const selfIndex = host.indexOf(selfSuffix)

  if (selfIndex >= 0) {
    const preHost = host.slice(0, selfIndex)
    const arr = preHost.split('.')
    // subdomain.lvh.me / subdomain.auth.locked.jp
    if (arr.length === 1 && arr[0].length > 0) {
      return arr[0]
    }
    // .lvh.me 等（tenant 無し）
    return ''
  }

  // custom domain `{tenant}.auth.{base}` → `.auth.` より前の単一ラベルを tenant とする。
  const authMarker = '.auth.'
  const authIndex = host.indexOf(authMarker)
  if (authIndex > 0) {
    const tenant = host.slice(0, authIndex)
    return tenant.includes('.') ? '' : tenant
  }

  return ''
}
